// extracted by mini-css-extract-plugin
export default {"anonymousAvatar":"KZk3mn","withBorder":"lvs33m","filter":"l4IWck"};